var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"Status__Icon",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({style:({color: _vm.corStatus})},on),[_vm._v("lens")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$tc(`status_entidade.${_vm.tooltip.toLowerCase()}`, 1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }